import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/translations';

export default function FeaturedStrategy() {
  const { language } = useLanguage();

  return (
    <Reveal delay={0.25}>
      <div style={{
        background: 'linear-gradient(135deg, rgba(0,255,200,0.08), rgba(0,170,255,0.05))',
        border: '1px solid rgba(0,255,200,0.2)',
        borderRadius: '16px',
        padding: '48px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Título */}
        <div style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '11px',
          color: '#00ffc8',
          letterSpacing: '3px',
          marginBottom: '12px',
          textTransform: 'uppercase',
        }}>
          {t('home.featured.label', language)}
        </div>

        <h3 style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: '42px',
          color: '#fff',
          marginBottom: '16px',
          letterSpacing: '2px',
        }}>
          ARES
        </h3>

        <div style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: '13px',
          color: '#888',
          marginBottom: '24px',
          letterSpacing: '1px',
        }}>
          {t('home.featured.subtitle', language)}
        </div>

        <p style={{
          fontSize: '15px',
          color: '#aaa',
          lineHeight: '1.8',
          marginBottom: '32px',
          maxWidth: '700px',
        }}>
          {t('home.featured.description', language)}
        </p>

        {/* CTA */}
        <Link
          to="/strategies/ares"
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            background: '#00ffc8',
            color: '#0a0a12',
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: '11px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            borderRadius: '6px',
            textDecoration: 'none',
            transition: 'all 0.3s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,255,200,0.4)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          {t('home.featured.cta', language)}
        </Link>

        {/* Decoración de fondo */}
        <div style={{
          position: 'absolute',
          bottom: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          background: 'radial-gradient(circle, rgba(0,255,200,0.15), transparent)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }} />
      </div>
    </Reveal>
  );
}
